import { MenuItem as NovaMenuItem } from '@fme-nova/components'
import { default as MuiMenuItem, MenuItemProps } from '@mui/material/MenuItem'

import { createComponentWrapperWithRef } from '../../theme'

export const MenuItem = createComponentWrapperWithRef<MenuItemProps>(
  {
    mui: MuiMenuItem,
    nova: NovaMenuItem as unknown as typeof MuiMenuItem,
  },
  'MenuItem',
)
